import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function validateCenterOlPayment(ids: number[]) {
  return restApiClient.url(encodeNestedObject(API.centerOlPayments.validate.url, { ids })).post()
}
